import { promisify } from 'util';
import fs from 'fs';
import path from 'path';
import { ref } from '@vue/composition-api';

import useSyncTaskControlHandler from '@/renderer/views/desktop/FileManagement/FileSync/composition/SyncTaskControlHandler';
import { SpaceTag } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import { CoSyncInfo, CoSyncTaskConfig } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import {
  CoSyncReporter,
  ShowConfigDialogSource,
} from '@/renderer/views/desktop/FileManagement/FileSync/composition/CoSyncReporter';
import tips from '@/renderer/scripts/utils/tips';

export namespace SyncSelectFolder {
  export type RemotePathContext = {
    remotePath: string;
    spaceTag: SpaceTag;
    spaceId: string;
    spaceOrgId: number;
    teamId: number;
    teamPath: string;
  };
}

export default function useSelectFolderHandler() {
  const { methods: controlMethods } = useSyncTaskControlHandler();

  const shouldShowFoldSelector = ref(false);
  const foldSelectorConfig = ref<CoSyncInfo | undefined>(undefined);
  const foldSelectorLocalPath = ref<string | undefined>(undefined);
  const foldSelectorRemotePathContext = ref<SyncSelectFolder.RemotePathContext | undefined>(undefined);
  const isFoldSelectorCreateBaseLocal = ref(true);

  const methods = {
    reset() {
      // shouldShowFoldSelector.value = false;
      foldSelectorConfig.value = undefined;
      foldSelectorLocalPath.value = undefined;
      foldSelectorRemotePathContext.value = undefined;
      isFoldSelectorCreateBaseLocal.value = true;
    },

    // 选择好目录后，创建同步盘
    async onDialogSubmit(taskConfig: CoSyncTaskConfig) {
      methods.reset();

      await controlMethods.createSyncTask(taskConfig);
    },

    // 拖本地文件到页面
    async onLocalFileDrop(filePath: string) {
      CoSyncReporter.getInstance().reportShowConfigDialog(ShowConfigDialogSource.DropLocalFile);

      methods.reset();

      foldSelectorLocalPath.value = filePath;
      isFoldSelectorCreateBaseLocal.value = true;
      shouldShowFoldSelector.value = true;
    },

    // 选定远端文件创建同步
    showCreateDialogWithRemotePath(
      remotePathContext: SyncSelectFolder.RemotePathContext,
      from: ShowConfigDialogSource,
    ) {
      CoSyncReporter.getInstance().reportShowConfigDialog(from);

      methods.reset();

      foldSelectorRemotePathContext.value = remotePathContext;
      isFoldSelectorCreateBaseLocal.value = false;
      shouldShowFoldSelector.value = true;
    },

    // 同步本地文件夹 弹窗
    showCreateLocalDialog(from: ShowConfigDialogSource) {
      CoSyncReporter.getInstance().reportShowConfigDialog(from);

      methods.reset();

      isFoldSelectorCreateBaseLocal.value = true;
      shouldShowFoldSelector.value = true;
    },

    // 同步远端文件夹 弹窗
    showCreateRemoteDialog(from: ShowConfigDialogSource) {
      CoSyncReporter.getInstance().reportShowConfigDialog(from);

      methods.reset();

      isFoldSelectorCreateBaseLocal.value = false;
      shouldShowFoldSelector.value = true;
    },

    // 展示当前的配置
    showCertainConfigDialog(userChoice: CoSyncInfo, from: ShowConfigDialogSource) {
      CoSyncReporter.getInstance().reportShowConfigDialog(from);

      methods.reset();

      foldSelectorConfig.value = userChoice;
      isFoldSelectorCreateBaseLocal.value = userChoice.config.syncPath.isCreateBaseLocal;
      shouldShowFoldSelector.value = true;
    },
  };

  return {
    shouldShowFoldSelector,
    foldSelectorConfig,
    foldSelectorLocalPath,
    foldSelectorRemotePathContext,
    isFoldSelectorCreateBaseLocal,

    methods,
  };
}
